import ScoutListPage from './ScoutListPage';

export default ScoutListPage;